import { render, staticRenderFns } from "./DialogNotifications.vue?vue&type=template&id=5e126d9a&scoped=true"
import script from "./DialogNotifications.vue?vue&type=script&lang=js"
export * from "./DialogNotifications.vue?vue&type=script&lang=js"
import style0 from "./DialogNotifications.vue?vue&type=style&index=0&id=5e126d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e126d9a",
  null
  
)

export default component.exports